import { ref, computed, watch, onMounted } from "vue";
import { addReCaptchaScript } from "~/utils/util";
import { UI_CONFIGS } from "~/utils/const";
import { useConfigStore } from "~/stores/config";

export const useRecaptcha = () => {
  const configStore = useConfigStore();
  const grecaptcha = ref(null);

  const recaptchaEnabled = computed(() => {
    return (
      configStore.getAutoloadConfigValue(UI_CONFIGS.RECAPTCHA_ENABLED) ===
      "true"
    );
  });

  const recaptchaSiteKey = computed(() => {
    return configStore.getAutoloadConfigValue(UI_CONFIGS.RECAPTCHA_SITE_KEY);
  });

  const loadRecaptcha = async () => {
    console.log("we do be loading");
    if (recaptchaEnabled.value && recaptchaSiteKey.value) {
      try {
        grecaptcha.value = await addReCaptchaScript(recaptchaSiteKey.value);
      } catch (error) {
        console.error("Failed to load reCAPTCHA:", error);
      }
    }
  };

  const executeRecaptcha = async () => {
    let recaptchaToken = null;
    if (recaptchaEnabled.value && grecaptcha.value) {
      try {
        recaptchaToken = await new Promise((resolve, reject) => {
          grecaptcha.value.ready(() => {
            grecaptcha.value
              .execute(recaptchaSiteKey.value, { action: "submit" })
              .then(resolve)
              .catch(reject);
          });
        });
      } catch (error) {
        console.error("reCAPTCHA execution failed:", error);
      }
    }
    return recaptchaToken;
  };

  // Watch for changes in recaptchaEnabled
  watch(recaptchaEnabled, async (newVal) => {
    if (newVal && !grecaptcha.value) {
      await loadRecaptcha();
    }
  });

  // Load on mount if enabled
  onMounted(async () => {
    if (recaptchaEnabled.value) {
      await loadRecaptcha();
    }
  });

  return {
    recaptchaEnabled,
    executeRecaptcha,
  };
};
